import React from "react"
import {
  listActualitesContainer,
  listActualitesHeaderContainer,
  actualitesContainer,
  listActualitesTitle,
  actualitesDescription,
  toutesNosActusResponsiveOnly,
} from "./actualites.module.scss"
import { Title } from "./actualites-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import RenderActualites from "./RenderActualites/render-actualites"
import { useActualites } from "gatsby-theme-blank/src/components/Home/Actualites/actualites-query"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"

//-----------------------Parent component---------------------------//

const ListActualites = () => {
  const data = useActualites()
  const finalData = getPublishedData(data.allNodeActualites.edges)
  if (finalData.length === 0) {
    return null
  }
  return (
    <div className={listActualitesContainer}>
      <div className={listActualitesHeaderContainer}>
        <Title className={listActualitesTitle}>
          {data.taxonomyTermZoneDefinie?.field_label || "À la une"}
        </Title>
        <div>
          <TransitionFade className="btn" link="/actualites">
            Toutes nos actus
          </TransitionFade>
        </div>
      </div>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={actualitesDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={actualitesContainer}>
        <RenderActualites actualiteData={finalData.slice(0, 10)} />
      </div>
      <div className={toutesNosActusResponsiveOnly}>
        <TransitionFade className="btn" link="/actualites">
          Toutes nos actus
        </TransitionFade>
      </div>
    </div>
  )
}

//-----------------------Parent component---------------------------//

export default ListActualites
